<template>
	<div class="correction-note-wrapper">
		<vs-popup
			:active.sync="active"
			title="Note de correction"
			:fullscreen="false"
			class="correction-note-popup"
			style="z-index: 9999999 !important"
		>
			<div class="correction-note-container">
				<p class="note-intro">
					Correction enregistrée. Ajoutez une note si utile.
				</p>
				<p class="note-context">
					<strong>{{ missionName }}</strong>
					<span class="note-period"> &mdash; {{ period }}</span>
					<span class="note-amount">{{ amountLabel }}</span>
				</p>

				<vs-textarea
					v-model="note"
					label="Note (facultative)"
					height="150px"
					placeholder="Pourquoi ce budget est-il corrigé ?"
				/>

				<div class="note-actions">
					<vs-button
						color="dark"
						type="flat"
						:disabled="isSaving"
						@click="skip()"
					>
						Passer
					</vs-button>
					<vs-button
						color="primary"
						type="filled"
						:disabled="isSaving"
						@click="save()"
					>
						Enregistrer
					</vs-button>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
export default {
	name: "CorrectionNotePopup",
	props: {
		popupActive: {
			type: Boolean,
			default: false,
		},
		missionName: {
			type: String,
			default: "",
		},
		period: {
			type: String,
			default: "",
		},
		amountLabel: {
			type: String,
			default: "",
		},
		/** Note already stored for this period, if any. */
		existingNote: {
			type: String,
			default: "",
		},
		isSaving: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			active: false,
			note: "",
		};
	},
	watch: {
		popupActive(val) {
			this.active = val;
			if (val) this.note = this.existingNote || "";
		},
		active(val) {
			this.$emit("update:popupActive", val);
		},
	},
	mounted() {
		/*
		 * Move the popup to <body>. It opens on top of the fullscreen "Afficher les
		 * contrats et budgets" popup, and while it stays nested inside that popup's
		 * DOM no z-index reliably lifts it above the dialog and its backdrop.
		 * CalculatorPopup does the same for the same clash.
		 */
		this.$nextTick(() => {
			if (this.$el && document.body) {
				document.body.appendChild(this.$el);
			}
		});
	},
	beforeDestroy() {
		if (this.$el && this.$el.parentNode) {
			this.$el.parentNode.removeChild(this.$el);
		}
	},
	methods: {
		save() {
			this.$emit("save", this.note || "");
		},
		skip() {
			this.$emit("skip");
		},
	},
};
</script>

<style>
/*
 * Unscoped on purpose: Vuesax renders .vs-popup and .vs-popup--background
 * itself, and a scoped rule is rewritten with a data attribute those internal
 * nodes do not carry, so it would never reach them.
 */
.correction-note-wrapper {
	position: fixed !important;
	top: 0 !important;
	left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	pointer-events: none !important;
	z-index: 9999999 !important;
}

.correction-note-wrapper > * {
	pointer-events: auto !important;
}

.correction-note-wrapper .vs-popup {
	z-index: 9999999 !important;
}

.correction-note-wrapper .vs-popup--background {
	z-index: 9999998 !important;
}

.correction-note-wrapper .vs-popup__content,
.correction-note-wrapper .vs-popup--content {
	z-index: 9999999 !important;
}
</style>

<style scoped>
.correction-note-container {
	padding: 20px;
	min-width: 420px;
}

.note-intro {
	margin: 0 0 0.5rem 0;
	font-size: 0.95rem;
	color: #388e3c;
}

.note-context {
	margin: 0 0 1rem 0;
	font-size: 0.9rem;
	color: #626262;
}

.note-period {
	color: #888;
}

.note-amount {
	font-weight: bold;
	font-family: "Monaco", "Menlo", monospace;
	margin-left: 0.5rem;
}

.note-actions {
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
	margin-top: 1.25rem;
}
</style>
